import React from 'react';



interface Expert {
  id: number;
  name: string;
  title: string;
  specialization: string;
  experience: string;
  certifications: string[];
  image: string;
  alt: string;
  expertise: string[];
}

interface ExpertiseShowcaseProps {
  className?: string;
}

const ExpertiseShowcase = ({ className = '' }: ExpertiseShowcaseProps) => {
  const experts: Expert[] = [
  {
    id: 1,
    name: 'Dr. Rajesh Kumar',
    title: 'Director of Regulatory Affairs',
    specialization: 'EU & US Market Authorization',
    experience: '18+ years',
    certifications: ['RAC (US)', 'RAC (EU)', 'Certified GMP Auditor'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_105b96742-1763300606680.png",
    alt: 'Professional Indian man in business suit with glasses standing confidently in modern pharmaceutical office',
    expertise: [
    'CTD/eCTD preparation',
    'EMA & FDA submissions',
    'Regulatory strategy development',
    'Post-approval variations']

  },
  {
    id: 2,
    name: 'Priya Sharma',
    title: 'Senior Regulatory Consultant',
    specialization: 'LATAM & MENA Markets',
    experience: '12+ years',
    certifications: ['ANVISA Specialist', 'WHO-GMP Lead Auditor', 'ISO 13485'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f0883a0c-1763299171534.png",
    alt: 'Professional Indian woman in navy blazer with confident smile in modern corporate office setting',
    expertise: [
    'ANVISA registrations',
    'MENA regulatory compliance',
    'Clinical data assessment',
    'Market entry strategy']

  },
  {
    id: 3,
    name: 'Amit Patel',
    title: 'GMP Compliance Specialist',
    specialization: 'Quality Systems & Audits',
    experience: '15+ years',
    certifications: ['WHO-GMP Auditor', 'EU-GMP Inspector', 'Six Sigma Black Belt'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_154473e0b-1766492982173.png",
    alt: 'Professional Indian man in white shirt and tie reviewing documents in pharmaceutical quality control laboratory',
    expertise: [
    'GMP gap analysis',
    'Audit preparation & support',
    'Quality system implementation',
    'CAPA management']

  },
  {
    id: 4,
    name: 'Dr. Meera Reddy',
    title: 'Regulatory Intelligence Lead',
    specialization: 'Global Regulatory Monitoring',
    experience: '10+ years',
    certifications: ['PharmD', 'Regulatory Intelligence Certified', 'Data Analytics'],
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_12520fba4-1763293360481.png",
    alt: 'Professional Indian woman in white lab coat analyzing pharmaceutical data on computer in modern research facility',
    expertise: [
    'Regulatory change monitoring',
    'Impact assessment',
    'Compliance forecasting',
    'Strategic advisory']

  }];


  const capabilities = [
  {
    icon: 'GlobeAltIcon',
    title: 'Global Reach',
    description: 'Expert knowledge across 60+ regulatory jurisdictions'
  },
  {
    icon: 'AcademicCapIcon',
    title: 'Certified Professionals',
    description: 'Team holds 50+ international regulatory certifications'
  },
  {
    icon: 'ChartBarIcon',
    title: 'Proven Track Record',
    description: '98% first-time approval rate across all submissions'
  },
  {
    icon: 'ClockIcon',
    title: 'Rapid Response',
    description: '24-hour turnaround on critical regulatory queries'
  }];


  return;


































































































};

export default ExpertiseShowcase;